import { SelectedArea } from 'src/app/shared/area-select.component';
import { BaseEntity } from '../base-entity';


export class FormQua042Filter extends BaseEntity {
    lote_origem?: string;
    lote_saida?: string;
    // tslint:disable-next-line: variable-name
    centro_ensaque?: string;
    // tslint:disable-next-line: variable-name
    contrato_juridico: string;
    // tslint:disable-next-line: variable-name
    data_ensaque_inicial?: Date;
    // tslint:disable-next-line: variable-name
    data_ensaque_final?: Date;
    // tslint:disable-next-line: variable-name
    safra?: string;
    // tslint:disable-next-line: variable-name
    hibrido_rnc?: string;
    // tslint:disable-next-line: variable-name
    is_incomplete: boolean;
    responsavel_pelo_apontamento?: string;
    origem_negocio?: SelectedArea;
    numero_campo: string;
}
